import { useRef, useEffect } from 'react'
import Button from '../Button.jsx'
import Field from '../form/Field.jsx'
import Hidden from '../form/Hidden.jsx'
import { ThirdPartyApiList } from '../../repo/ThirdPartyApiRepo'

export default function AdminTeamsForm({team, images, errors, isSubmitting}) {
  const idRef = useRef()
  const nameRef = useRef()
  const imageIdRef = useRef()
  const thirdPartyLabelRef = useRef()
  const thirdPartyIdRef = useRef()

  useEffect(() => {
    if (team) {
      idRef.current.value = team.id;
      nameRef.current.value = team.name;
      imageIdRef.current.value = team.image_id;
      thirdPartyLabelRef.current.value = team.third_party_label;
      thirdPartyIdRef.current.value = team.third_party_id;
    } else {
      imageIdRef.current.value = ""
    }
  }, [team]);

  function nameHasError() {
    if (errors && errors.name) {
      return "Nome inválido"
    }

    return ""
  }

  function imageIdHasError() {
    if (errors && errors.name) {
      return "Nome inválido"
    }

    return ""
  }

  const transformImageData = (images) => {
    let list = images.map((image) => ({
      key: image.id,
      value: image.id,
      name: image.filename
    }))

    if (images.length > 1) {
      list.unshift({
        key: "",
        value: "",
        name: "Selecione uma equipe"
      });
    }

    return list;
  }

  return(
    <>
      <Field type={"input"} ref={nameRef} name={"name"} id={"name"} label={"Nome"} required={""} disabled={isSubmitting} error={nameHasError()}/>

      <Field
        type={"select"}
        name={"image_id"}
        id={"image_id"}
        label={"Escudo"}
        required={""}
        options={transformImageData(images)}
        defaultValue={''}
        error={imageIdHasError()}
        disabled={isSubmitting}
        ref={imageIdRef}/>

      <Field
        type={"select"}
        name={"third_party_label"}
        id={"third_party_label"}
        label={"API de Terceiros"}
        required={""}
        options={ThirdPartyApiList()}
        defaultValue={''}
        disabled={isSubmitting}
        ref={thirdPartyLabelRef}/>

      <Field
        type={"input"}
        name={"third_party_id"}
        id={"third_party_id"}
        label={"ID de Terceiros"}
        required={""}
        disabled={isSubmitting}
        ref={thirdPartyIdRef}/>

      {team && team.id && (
        <Hidden ref={idRef} name={"id"} id={"id"} />
      )}
      <Button styleName="blue" disabled={isSubmitting} >
        {isSubmitting ? 'Saving...' : 'Save'}
      </Button>
    </>
  )
}
